import React from 'react'

import moment from 'moment'
import ReactExport from 'react-export-excel'

const { ExcelFile } = ReactExport
const { ExcelSheet } = ReactExport.ExcelFile
const { ExcelColumn } = ReactExport.ExcelFile

const ExportExcel = ({ memberReportList, children }) => {
  const formatedList =
    memberReportList &&
    memberReportList.map(reportItem => ({
      ...reportItem,
      address: `${
        reportItem.address.street ? `${reportItem.address.street},` : ''
      } ${reportItem.address.city}, ${reportItem.address.state} - ${
        reportItem.address.zip
      }`,
    }))
  return (
    <ExcelFile
      element={children}
      filename={`Assigned Member Report ${moment(new Date()).format('MMDDYY')}`}
    >
      <ExcelSheet data={formatedList} name="Report">
        <ExcelColumn label="Status" value="status" />
        <ExcelColumn label="Member Id" value="memberId" />
        <ExcelColumn label="Type" value="memberType" />
        <ExcelColumn label="First Name" value="firstName" />
        <ExcelColumn label="Last Name" value="lastName" />
        <ExcelColumn label="Date Of Birth" value="dateOfBirth" />
        <ExcelColumn label="PCP Name" value="pcpName" />
        <ExcelColumn label="NPI" value="NPI" />
        <ExcelColumn label="Assignment Date" value="assignmentDate" />
        <ExcelColumn label="Address" value="address" />
        <ExcelColumn label="Phone" value="phone" />
        <ExcelColumn label="Email" value="email" />
      </ExcelSheet>
    </ExcelFile>
  )
}

export default ExportExcel
